import SVGIcon from '../atoms/icons';

interface ActionsProps {
	onViewClick?: () => void;
	onEditClick?: () => void;
	onDeleteClick?: () => void;
}

const Actions = ({ onViewClick, onEditClick, onDeleteClick }: ActionsProps) => (
	<div className="flex items-center gap-3 h-full">
		{onViewClick && (
			<SVGIcon
				className="fill-primary h-3 w-auto cursor-pointer"
				icon="Eye"
				onClick={onViewClick}
			/>
		)}
		{onEditClick && (
			<SVGIcon
				className="fill-primary h-3 w-auto cursor-pointer"
				icon="Pencil"
				onClick={onEditClick}
			/>
		)}
		{onDeleteClick && (
			<SVGIcon
				className="stroke-red fill-red h-3 w-auto cursor-pointer"
				icon="Delete"
				onClick={onDeleteClick}
			/>
		)}
	</div>
);

export default Actions;
